import React from "react";
import "./research.css";
const Research = () => {
  return (
    <div className="my-5 ">
      <h1 className="my-5 research-experience">research Expereince</h1>
      <div className="d-flex container justify-content-center align-items-center ">
        <div className="table table-responsive">
          <thead>
            <th className="border py-2">Topic</th>
            <th className="border py-2">Duration</th>
            <th className="border py-2">Details</th>
          </thead>
          <tbody>
            <tr>
              <td className="col-2 border research-name  fw-bold">
                Research on Image Segmentation for road crack detection.
              </td>
              <td className="col-1 border text-start">
                January 2020 – August 2020 <br /> (Undergraduate Research)
              </td>
              <td className="col-2 border responsibility">
                CNNs for Deep Learning based image segmentation. Used Python and
                TensorFlow for ensuring efficient computation.
              </td>
            </tr>
            <tr>
              <td className="col-2 border research-name  fw-bold">
                Facial Recognition with a moving camera on different lights and
                facial orientations using TensorFlow and raspberry pi.
              </td>
              <td className="col-1 border text-start">
                May 2019 – December 2019 <br /> (Capstone Project, NSU)
              </td>
              <td className="col-2 border responsibility">
                Worked with tensorflow to recognize a person while moving and in
                different lights. A huge data training work done in this project
                to identify the face in different orientations.
              </td>
            </tr>
          </tbody>
        </div>
      </div>
    </div>
  );
};

export default Research;
